import React, {useState} from 'react';
import {arrayIncludes} from 'ts-extras';
import isEqual from 'lodash/isEqual';

import {
    convertToLegoOptions,
    deselectSameCountryRegions
} from 'client/common/components/audience-settings/helpers';
import {AudienceCategoryValue} from 'client/common/types';
import {SelectWithTags} from 'client/common/components/lego';
import {Option} from 'client/common/components/inline-select/types';

interface Props {
    handleGeoChange: (geo: string[]) => void;
    handleCitySizeChange: (citySizes: string[]) => void;
    defaultGeo: string[];
    defaultCitySize: string[];
    geoOptions: Option[];
    citySizeOptions: Option[];
    geoValues: string[] | undefined;
    citySizeValues: string[] | undefined;
    disabled: boolean;
}

const CITYSIZE_VALUE_2 = '2';
const CITYSIZE_VALUE_3_4 = '3-4';
const CITYSIZE_VALUES = [CITYSIZE_VALUE_2, CITYSIZE_VALUE_3_4] as const;

const CITY_VALUES_MAP = {
    [CITYSIZE_VALUE_2]: 'city_size_2',
    [CITYSIZE_VALUE_3_4]: 'city_size_3_4'
};

const toInternalCitySize = (item: string): string => {
    if (arrayIncludes(CITYSIZE_VALUES, item)) {
        return CITY_VALUES_MAP[item];
    }

    return item;
};

// eslint-disable-next-line max-statements
export const GeoCitySizeSelect = (props: Props) => {
    const {
        handleCitySizeChange,
        citySizeOptions,
        citySizeValues = [],
        defaultCitySize,
        handleGeoChange,
        geoOptions,
        geoValues,
        defaultGeo,
        disabled
    } = props;

    const citySizeValuesArr: string[] = [];

    if (citySizeValues.includes('2')) {
        citySizeValuesArr.push(CITY_VALUES_MAP['2']);
    }
    if (citySizeValues.includes('3') && citySizeValues.includes('4')) {
        citySizeValuesArr.push(CITY_VALUES_MAP['3-4']);
    }

    const [selectedGeo, setSelectedGeo] = useState<string[]>(geoValues ?? defaultGeo);
    const [selectedCitySize, setSelectedCitySize] = useState<string[]>(
        citySizeValuesArr ?? defaultCitySize.map(toInternalCitySize)
    );

    // eslint-disable-next-line max-statements
    const handleChange = (value: AudienceCategoryValue[]) => {
        const changedCitySize: string[] = [];
        let changedGeo: AudienceCategoryValue[] = [];

        // приходится вытаскивать geo и сitySize из списка в котором они смешаны
        value.forEach(item => {
            if (item === CITY_VALUES_MAP[CITYSIZE_VALUE_2]) {
                changedCitySize.push(CITY_VALUES_MAP[CITYSIZE_VALUE_2]);
            } else if (item === CITY_VALUES_MAP[CITYSIZE_VALUE_3_4]) {
                changedCitySize.push(CITY_VALUES_MAP[CITYSIZE_VALUE_3_4]);
            } else if (item) {
                changedGeo.push(item);
            }
        });

        if (!isEqual(selectedGeo, changedGeo)) {
            changedGeo = deselectSameCountryRegions(selectedGeo, changedGeo);

            setSelectedGeo(changedGeo);
            void handleGeoChange(changedGeo);
        }

        if (!isEqual(selectedCitySize, changedCitySize)) {
            setSelectedCitySize(changedCitySize);
            // отправляем на сервер нормальные цифры вместо внутренних(city_size_2/city_size_3_4)
            const citySizeForServer =
                changedCitySize.reduce((prev: string[], curr: string) => {
                    if (curr === CITY_VALUES_MAP[CITYSIZE_VALUE_3_4]) {
                        prev.push(...['3', '4']);

                        return prev;
                    } else if (curr === CITY_VALUES_MAP[CITYSIZE_VALUE_2]) {
                        prev.push('2');

                        return prev;
                    }
                }, []) ?? [];

            void handleCitySizeChange(citySizeForServer);
        }
    };

    const options = [
        ...convertToLegoOptions(
            citySizeOptions.map(item => {
                item.value = toInternalCitySize(item.value);

                return item;
            })
        ),
        // ...convertToLegoOptions(geoOptions)
        {items: convertToLegoOptions(geoOptions)}
    ];

    return (
        <SelectWithTags
            onChange={e => handleChange(e.target.value)}
            options={options}
            value={[...selectedCitySize, ...selectedGeo]}
            size='m'
            disabled={disabled}
            minSelected={1}
            width='max'
            view='dl-clear'
        />
    );
};
